var _path, _path2, _path3, _path4, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBalloon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M420.032 511.333a7.749 7.749 0 01-9.915-3.316c-5.806-10.418-19.114-30.677-37.303-36.232-17.18-5.246-24.664-4.466-38.254-3.047-8.421.878-18.903 1.97-34.609 1.97-36.937 0-57.28-28.576-57.28-80.464h15.489c0 18.774 3.018 34.454 8.729 45.346 6.926 13.207 17.741 19.628 33.062 19.628 14.901 0 24.937-1.047 33.002-1.888 14.575-1.518 24.201-2.522 44.384 3.64 23.478 7.17 39.419 31.083 46.322 43.488 2.221 3.993.549 9.023-3.627 10.875zM87.356 165.828C87.356 74.244 161.6 0 253.186 0s165.828 74.244 165.828 165.828c0 123.309-74.244 216.853-165.828 216.853S87.356 282.05 87.356 165.828z",
    fill: "#fdf6e3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M312.046 359.963c-91.584 0-165.828-100.631-165.828-216.853 0-59.245 31.075-111.225 77.809-140.553-77.68 13.781-136.67 81.637-136.67 163.271 0 116.222 74.244 216.853 165.828 216.853 27.712 0 53.83-8.578 76.791-23.94a132.98 132.98 0 01-17.93 1.222z",
    fill: "#fdf6e3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M221.72 402.972h61.512c7.029 0 12.726-5.698 12.726-12.726 0-7.029-5.698-12.726-12.726-12.726H221.72c-7.029 0-12.726 5.698-12.726 12.726 0 7.027 5.698 12.726 12.726 12.726z",
    fill: "#fdf6e3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M239.75 390.244c0-7.029 5.698-12.726 12.726-12.726H221.72c-7.029 0-12.726 5.698-12.726 12.726s5.698 12.726 12.726 12.726h30.756c-7.028 0-12.726-5.697-12.726-12.726z",
    fill: "#fdf6e3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 332.374,
    cy: 112.454,
    r: 32.012,
    fill: "#fdf6e3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalloon);
export default __webpack_public_path__ + "static/media/balloon.17323a57.svg";
export { ForwardRef as ReactComponent };